/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const MetaIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#415DAE',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={className}
      onClick={onClick}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_7734_2745)">
        <path
          d="M14.7665 3.35449C13.1266 3.35449 11.8446 4.58965 10.6841 6.15871C9.0894 4.1282 7.75573 3.35449 6.15971 3.35449C2.90584 3.35449 0.41272 7.58914 0.41272 12.0712C0.41272 14.876 1.76963 16.645 4.04241 16.645C5.67823 16.645 6.85471 15.8738 8.94616 12.2179C8.94616 12.2179 9.81799 10.6783 10.4178 9.61773C10.6279 9.95707 10.8488 10.3221 11.0818 10.7147L12.0626 12.3645C13.973 15.5616 15.0375 16.645 16.9663 16.645C19.1805 16.645 20.4127 14.8518 20.4127 11.9887C20.4127 7.29582 17.8634 3.35449 14.7665 3.35449ZM7.35131 11.228C5.65561 13.8861 5.06901 14.4819 4.12491 14.4819C3.15331 14.4819 2.57588 13.6289 2.57588 12.1079C2.57588 8.85402 4.19827 5.5268 6.13225 5.5268C7.17956 5.5268 8.05479 6.13164 9.39538 8.05086C8.12241 10.0034 7.35131 11.228 7.35131 11.228ZM13.7511 10.8934L12.5785 8.9377C12.2611 8.4216 11.957 7.94734 11.6636 7.51254C12.7205 5.88133 13.5922 5.06852 14.629 5.06852C16.783 5.06852 18.5062 8.23992 18.5062 12.1354C18.5062 13.6203 18.0199 14.4819 17.0122 14.4819C16.0464 14.4819 15.5849 13.844 13.7511 10.8934Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_7734_2745">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.41272)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
